if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let url = document.URL
    if( url.indexOf( "experiences-in-oregon?showform" ) != "-1" ){
        let btn_planning = document.querySelector( ".btn-planning" )
        if( btn_planning )
            btn_planning.click()
    }

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });


    if(document.querySelector('.location-quad')){
        let pointsMap = document.querySelectorAll('.location-quad .map-point');
        let imagesPoints = document.querySelectorAll('.location-quad__text .content-images');
        let lastClick = null;

        pointsMap.forEach((point)=>{
            point.addEventListener('click',(e)=>{
                let data = e.target.dataset.point;

                if(lastClick){
                    lastClick.classList.remove('active');
                }

                point.classList.add('active');

                imagesPoints.forEach((image)=>{
                    image.classList.toggle('active', data == image.dataset.point);
                })

                lastClick = point;
            })
        })

        pointsMap[0].click();
    }
	
})();